import React, { createContext, useContext, useState } from 'react';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
   const [isTourOpen, setIsTourOpen] = useState(false);
   const [tourSteps, setTourSteps] = useState([]);

   // Track if user has completed tours
   const [completedTours, setCompletedTours] = useState(() => {
      const saved = localStorage.getItem('completedTours');
      return saved ? JSON.parse(saved) : {};
   });

   const startTour = (steps, tourId) => {
      setTourSteps(steps);
      setIsTourOpen(true);
   };

   const endTour = (tourId) => {
      setIsTourOpen(false);
      if (tourId) {
         setCompletedTours(prev => {
            const updated = { ...prev, [tourId]: true };
            localStorage.setItem('completedTours', JSON.stringify(updated));
            return updated;
         });
      }
   };

   return (
      <TourContext.Provider
         value={{
            isTourOpen,
            tourSteps,
            startTour,
            endTour,
            completedTours
         }}
      >
         {children}
      </TourContext.Provider>
   );
};

export const useTour = () => useContext(TourContext);